import styled from 'styled-components';
import { UserAvatarStyleProps } from './UserAvatar.interface'; 

export const UserAvatarWrapper = styled.div<UserAvatarStyleProps>`
  position: relative;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: 50%;
  background-color: ${(props) => props.negative
    ? ({ theme }) => theme.colors.primary
    : ({ theme }) => theme.colors.white
  };
  display: flex;
  justify-content: center;
  align-items: center;
  .avatar-initials {
    font-size: ${({ fontSize }) => fontSize ? fontSize : '16px'};
    font-weight: bold;
    text-transform: uppercase;
    color: ${(props) => props.negative
      ? ({ theme }) => theme.colors.white
      : ({ theme }) => theme.colors.primary
    };
  }
`;
